export default {
  title: 'Renombrar',
  form: {
    label: {
      title: 'Título *',
      description: 'Descripción (opcional)',
    },
    rule: {
      emptyTitle: 'El título es obligatorio',
      titleMaxCharacters: 'El título debe tener hasta %{titleMaxCharacters} caracteres',
      descriptionMaxCharacters: 'La descripción debe tener hasta %{descriptionMaxCharacters} caracteres',
    },
  },
  label: {
    button: {
      confirmButton: 'Guardar',
      cancelButton: 'Cancelar',
    },
  },
};
